module.exports = __webpack_public_path__ + "img/大厦.c84855da.png";